
import React from 'react';

const MediaContent = () => (
  <p>
    Media Content
  </p>
);

export default MediaContent;